import { Heading } from 'evergreen-ui'
import styled from 'styled-components'

export const Headline = styled(Heading)`
  font-size: 28px;
  font-weight: 500;
  line-height: 39.06px;
`
